// Pricing helpers for INR formatting and rate parsing.

export function formatINR(amount, opts = {}) {
  const { decimals = false } = opts;
  if (decimals || (amount > 0 && amount < 100)) {
    // preserve decimals for small unit rates like 1.50
    const fixed = Math.round(amount * 100) / 100;
    return "\u20B9" + fixed.toLocaleString("en-IN", { minimumFractionDigits: fixed % 1 === 0 ? 0 : 2, maximumFractionDigits: 2 });
  }
  const rounded = Math.round(amount);
  return "\u20B9" + rounded.toLocaleString("en-IN");
}

// Parse a rupee text like "₹1,25,000" or "₹1.50" -> number
export function parseRupees(text) {
  if (text === null || text === undefined) return 0;
  if (typeof text === "number") return text;
  const s = String(text).replace(/[^0-9.]/g, "");
  const n = parseFloat(s);
  return Number.isFinite(n) ? n : 0;
}

// Compute an item's total using its unit rate + quantity if applicable.
export function itemTotal(item) {
  if (item.unitRate && item.quantity) {
    return item.unitRate * item.quantity;
  }
  return parseRupees(item.price);
}

// Printing calculator config + formula.
export const PRINT_CONFIG = {
  sizes: [
    { key: "a5", label: "A5 (148 × 210 mm)", base: 0.28 },
    { key: "demy", label: 'Demy (5.5" × 8.5")', base: 0.34 },
    { key: "royal", label: 'Royal (6.14" × 9.21")', base: 0.4 },
  ],
  gsm: [
    { key: "80", label: "80 gsm", multiplier: 1 },
    { key: "100", label: "100 gsm", multiplier: 1.28 },
  ],
  methods: [
    { key: "digital", label: "Digital", multiplier: 1, setupFee: 0 },
    { key: "offset", label: "Offset", multiplier: 0.62, setupFee: 8000 },
  ],
  covers: [
    { key: "soft", label: "Softcover", surcharge: 15 },
    { key: "hard", label: "Hardcover", surcharge: 38 },
  ],
};

// Returns { perCopy, setup, subtotal, gst, total }
export function calculatePrint({ sizeKey, gsmKey, methodKey, coverKey, pages, quantity }) {
  const cfg = PRINT_CONFIG;
  const size = cfg.sizes.find((s) => s.key === sizeKey) || cfg.sizes[0];
  const gsm = cfg.gsm.find((g) => g.key === gsmKey) || cfg.gsm[0];
  const method = cfg.methods.find((m) => m.key === methodKey) || cfg.methods[0];
  const cover = cfg.covers.find((c) => c.key === coverKey) || cfg.covers[0];

  const safePages = Math.max(1, parseInt(pages || 0, 10) || 0);
  const safeQty = Math.max(1, parseInt(quantity || 0, 10) || 0);

  const interiorPerCopy = size.base * gsm.multiplier * method.multiplier * safePages;
  const perCopy = interiorPerCopy + cover.surcharge;
  const setup = method.setupFee;
  const subtotal = perCopy * safeQty + setup;
  const gst = subtotal * 0.18;
  const total = subtotal + gst;

  return {
    perCopy,
    setup,
    subtotal,
    gst,
    total,
    breakdown: {
      size: size.label,
      gsm: gsm.label,
      method: method.label,
      cover: cover.label,
      pages: safePages,
      quantity: safeQty,
    },
  };
}
